import Divider from "../../components/divider/Divider";
import FooterCTA from "../../components/footerCTA/FooterCTA";
import Transition from "../../components/transition/Transition";
import AboutMeHero from "./aboutMeHero/AboutMeHero";
import AboutMeInfo from "./aboutMeInfo/AboutMeInfo";

export default function AboutMe (){
    return(
        <Transition emojiName="sparkles">

            <AboutMeHero />

            <Divider />

            <AboutMeInfo />

            <Divider />

            <FooterCTA />

        </Transition>
    );
}